import { useLocation, useParams } from "react-router-dom";
import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import { useEffect, useState } from "react";
import { getUserSession } from "../../../util/core/Session";
import config from '../../../../application/config/config';
import Fetch from "../../../util/core/Fetch";
import FileUploadS3 from "./components/CustomFileUploadS3/FileUploadS3";

function Form() {
    const { id, idTutorial } = useParams(); 
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const session = getUserSession();

    const pathBackEnd = 'core/tutorial/';
    const paths = {
      endpoint: config.endpoints.backend + pathBackEnd + 'getById',
      createLog: config.endpoints.backend + pathBackEnd + 'createLog',
      updateProgress: config.endpoints.backend + pathBackEnd + 'updateProgress'
    };

    const location = useLocation();
    const { title } = location.state || {}; 

    async function createLog() {
        const newLog = {
            core_application_instance_id: session.user.application_instance_id,
            core_user_id: session.user.id,
            core_module_id: idTutorial,
            core_video_id: id,
            current_progress: '0',
            viewed: '1',
            deleted: '0'
        };
        await Fetch.put(paths.createLog, newLog);
    };

    async function updateProgress(progress) {
        const formattedProgress = !progress || progress === 100 ? '0' : JSON.stringify(progress);

        const newLog = {
            core_application_instance_id: session.user.application_instance_id,
            core_user_id: session.user.id,
            core_module_id: idTutorial,
            core_video_id: id,
            current_progress: formattedProgress,
            viewed: '1',
            deleted: '0'
        };
        await Fetch.put(paths.updateProgress, newLog);
    };

    const getForm = (values) => {
        return {
            showSubmitButton:false,
            validateOnChange: true,
            labelTitle: title,
            fields: [
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    validations: {
                        required: true
                    },
                    readOnly: true, 
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    readOnly: true, 
                    columnSize: 12
                },
                {
                    name: 'video',
                    type: 'customInput',
                    label: 'Vídeo',
                    validations: {
                        required: true
                    },
                    component: (params) => {
                        return (
                            <FileUploadS3
                                logFunction={() => createLog()}
                                updateProgress={(currentProgress) => updateProgress(currentProgress)}
                                file={params.values.video}
                                disabled
                            />
                    )},
                    readOnly: true, 
                    columnSize: 12
                },
            ],
            values: values,
        };
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Fetch.post(paths.endpoint, {
                    core_application_instance_id: session.user.application_instance_id,
                    id: idTutorial
                });

                if (response.children) {
                    const childDetail = response.children.find(child => child._id === id);
                    if (childDetail) {
                        const formSetup = getForm(childDetail);
                        setForm(formSetup);
                        setFormContent(
                            <CustomFormContainer 
                                form={formSetup}
                                content={<CustomForm form={formSetup} />}
                            />
                        );
                    } else {
                        throw new Error("Tutorial específico não encontrado");
                    }
                } else {
                    throw new Error("Dados não recebidos corretamente");
                }
                setLoading(false);
            } catch (err) {
                setError('Erro ao carregar dados');
                setLoading(false);
                console.error('Erro ao buscar dados:', err);
            }
        }
        
        fetchData();
    }, [idTutorial, session.user.application_instance_id, id]);
    if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div>
            {form && (
                <div>{formContent}</div>
            )}
        </div>
    );
}

export default Form;
